"use client"
import { cx } from 'class-variance-authority';
import React, { ReactNode } from 'react'
import Footer from './Footer';
import MobileNav from './MobileNav';
import Navbar from './Navbar';
import useWindowSize from '@/utils/useWindowSize';

type LayoutProps = {
    children: ReactNode;
  };
  
const ClientLayout = ({ children }: LayoutProps) => {
    const { mobile } = useWindowSize();
    return (
      <div >
        {mobile ? <MobileNav /> : <Navbar />}
        <main className={cx({
          'min-h-screen  bg-background dark:bg-dark-background dark:text-white z-10': true,
        })}>
          {children}
        </main>
        <Footer />
      </div>
    );
  };

export default ClientLayout;